<template>
  <div class="add-user">
    <form @submit.prevent="handleSubmit" class="user-form">
        <div class="form-field">
          <div class="form-group">
            <label for="phone">Телефон контакта:</label>
            <input type="phone" id="phone" v-model="phone" required>
          </div>
          <div class="form-group">
            <label for="inn">ИНН компании:</label>
            <input type="inn" id="inn" v-model="inn" required>
          </div>
        </div>
      <button type="submit">Добавить</button>
    </form>
    <br>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { createToaster } from "@meforma/vue-toaster";


export default {
  props:['companyId'],
  setup(props){

    const store = useStore()
    const toaster = createToaster()

    const phone = ref('')
    const inn = ref('')

    const handleSubmit = async () => {
      // try{
      //   const res = await store.dispatch('',{
      //     phone:phone.value,
      //     inn:inn.value,
      //     company_id:props.companyId
      //   })
      //   phone.value = ''
      //   inn.value = ''
      // } catch(err){
      //   toaster.error(err.message)
      // }
      
    }
    return {handleSubmit,inn,phone}
  },
 
};
</script>


<style scoped>
.add-user{
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
}
.user-form{
  display: flex;
  flex-direction: column;
}

.form-field{
  margin-top: 15px;
/*  display: flex;*/
  align-items: center;
  margin-left: 10px;
}

.form-group{
  display: flex;
  flex-direction: column;
}

input{
  width: 95%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  max-width: 100px;
  margin: 5px auto;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
